import axiosInstance from "../hooks/api";

export async function postSacramentDraft(draft) {
  const { kind, sacramentType, birthDate, age, data, siblingGroupId } = draft;

  if (kind === "infant_baptism") {
    const baptismRequestPayload = {
      birth_date: data.birth_date || birthDate || "",
      child_name: data.child_name,
      birth_place: data.birth_place,
      mother_name: data.mother_name,
      mother_phone: data.mother_phone,
      mother_email: data.mother_email,
      father_name: data.father_name,
      father_phone: data.father_phone,
      father_email: data.father_email,
      address_line_1: data.address_line_1,
      city: data.city,
      state: data.state,
      zip_code: data.zip_code,
      godfather_name: data.godfather_name,
      godfather_religion: data.godfather_religion,
      godfather_phone: data.godfather_phone,
      godfather_email: data.godfather_email,
      godmother_name: data.godmother_name,
      godmother_religion: data.godmother_religion,
      godmother_phone: data.godmother_phone,
      godmother_email: data.godmother_email,
      comments: data.comments || null,
    };
    if (siblingGroupId) {
      baptismRequestPayload.sibling_group_id = siblingGroupId;
    }
    return axiosInstance.post("/public/baptism", baptismRequestPayload);
  }

  if (kind === "child") {
    const payload = new FormData();
    payload.append("sacrament_type", sacramentType);
    payload.append("form_type", "child");
    payload.append("full_name", data.child_name);
    payload.append("birth_date", birthDate);
    payload.append("phone", data.phone);
    payload.append("email", data.mother_email || data.father_email || "");
    payload.append("address_line_1", data.address_line_1);
    payload.append("city", data.city);
    payload.append("state", data.state);
    payload.append("zip", data.zip);
    payload.append("language", data.child_language);
    const { documents: files, ...rest } = data;
    payload.append("form_data", JSON.stringify({ ...rest, age, birth_date: birthDate }));
    if (siblingGroupId) {
      payload.append("sibling_group_id", siblingGroupId);
    }
    if (files && files.length > 0) {
      Array.from(files).forEach((f) => payload.append("documents[]", f));
    }
    return axiosInstance.post("/public/sacrament-registrations", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  if (kind === "adult") {
    const formDob = data.birth_date || birthDate || "";
    const payload = new FormData();
    payload.append("sacrament_type", sacramentType);
    payload.append("form_type", "adult");
    payload.append("full_name", data.full_name);
    payload.append("birth_date", formDob);
    payload.append("phone", data.phone);
    payload.append("email", data.email || "");
    payload.append("address_line_1", data.address_line_1);
    payload.append("city", data.city);
    payload.append("state", data.state);
    payload.append("zip", data.zip);
    payload.append("language", data.language);
    const { documents: files, ...rest } = data;
    payload.append("form_data", JSON.stringify({ ...rest, birth_date: formDob }));
    if (siblingGroupId) {
      payload.append("sibling_group_id", siblingGroupId);
    }
    if (files && files.length > 0) {
      Array.from(files).forEach((f) => payload.append("documents[]", f));
    }
    return axiosInstance.post("/public/sacrament-registrations", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  // not_applicable / skip
  return null;
}
